module.exports = __webpack_public_path__ + "img/logo.a7a40ae1.svg";